//import "@trussworks/react-uswds/lib/uswds.css";

import ConfirmModal from "components/ConfirmModal";
import ErrorModal from "components/ErrorModal";
import TimeoutModal from "components/TimeoutModal";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import Account from "pages/account";
import { Route, Routes } from "react-router-dom";
import { closeModal, selectErrorModal } from "store/errorModalSlice";
import { selectTimeoutModal } from "store/timeoutModalSlice";
import "./App.css";
import MainRoutes from "./app/MainRoutes";
import LoginCallback from "./pages/loginCallback";
//import "./styles/loaderOptions.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoggedOut from "./pages/loggedout";
import "./styles/rfi.css";

const App = () => {
  const errorModal = useAppSelector(selectErrorModal);
  const timeoutModal = useAppSelector(selectTimeoutModal);
  const dispatch = useAppDispatch();
  
  return (
    <>
      <Routes>
        <Route path="loggedout" element={<LoggedOut />} />
        <Route path="account" element={<Account />} />
        <Route path="login/callback" element={<LoginCallback />} />
        <Route path="/*" element={<MainRoutes />} />
      </Routes>
      <ToastContainer
        position="bottom-left"
        autoClose={500}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}    
        draggable
        pauseOnHover
        theme="light"
        role="alert"
        limit={1}
      />
      <ErrorModal
        show={errorModal.show}
        handleClose={() => dispatch(closeModal())}
        title={errorModal.title}
        description={""}      
      >
        {errorModal.isHtml? <span dangerouslySetInnerHTML={{ __html: errorModal.errorMessage }}></span> : errorModal.errorMessage}
      </ErrorModal>
      <TimeoutModal
        show={timeoutModal.show}
        onTimeout={timeoutModal.onTimeout}
        onStayLoggedIn={timeoutModal.onStayLoggedIn}
        title={timeoutModal.title}
        getRemainingTime={timeoutModal.getRemainingTime}
        description={""}
      >
        {timeoutModal.timeoutMessage}
      </TimeoutModal>
      <ConfirmModal />
    </>
  );
};

export default App;
